import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAirHorn = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 21,
	viewBox: "0 0 24 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M0.75 0.289795C1.16421 0.289795 1.5 0.625585 1.5 1.03979C1.5 2.51435 2.85944 4.07954 5.56292 5.32069C8.19672 6.52984 11.8362 7.28979 15.75 7.28979H15.7859C16.6524 6.36652 17.8839 5.78979 19.25 5.78979C21.8734 5.78979 24 7.91645 24 10.5398C24 13.1632 21.8734 15.2898 19.25 15.2898C17.8839 15.2898 16.6524 14.7131 15.7859 13.7898H15.75C11.8362 13.7898 8.19672 14.5497 5.56292 15.7589C2.85944 17 1.5 18.5652 1.5 20.0398C1.5 20.454 1.16421 20.7898 0.75 20.7898C0.335786 20.7898 0 20.454 0 20.0398V1.03979C0 0.625585 0.335786 0.289795 0.75 0.289795ZM19.25 7.53979C18.9739 7.53979 18.75 7.76365 18.75 8.03979C18.75 8.31589 18.9739 8.53979 19.25 8.53979C20.3739 8.53979 21.25 9.41589 21.25 10.5398C21.25 10.8159 21.4739 11.0398 21.75 11.0398C22.0261 11.0398 22.25 10.8159 22.25 10.5398C22.25 8.86369 20.9261 7.53979 19.25 7.53979Z",
		fill: "#C6CDD2"
	})
});
export default SvgAirHorn;
